import defaultUrl from './urls.js';
let urls = {
    // 注册
    signin: 'api/users/register',
    // 获取手机注册短信
    signinSms: 'api/sms/register',
    // 获取手机登录短信
    loginSms: 'api/sms/login',
    // 账号密码登录
    pwdLogin: 'api/users/pwdlogin',
    // 验证码登录
    verifiyLogin: 'api/users/smslogin',
    // 用户详情
    userDetail: 'api/users/details',
    // 用户详情-编辑
    userDetailEdit: 'api/users/update',
    // 栏目列表
    columnList: 'api/column/getlist',
    // 栏目-分类列表
    columnCateList: 'api/column/getcate',
    // 栏目-全部商品分类
    columnAllCateList: 'api/column/columncate',
    // 栏目-商品分类(分类样式)
    columnGoodsCateList: 'api/column/getcolumngoodscate',
    // 栏目-分类商品(分类样式-商品)
    columnCateGoodsList: 'api/column/getcolumncategoods',
    // 栏目-商品列表(列表样式)
    columnGoodsList: 'api/column/getcolumngoods',
    // 栏目-自定义商品列表(政策扶持)
    columnDiyGoodsList: 'api/column/getcolumngoodscatecates',
    // 栏目-自定义商品列表-详情(政策扶持详情)
    columnDiyGoodsDetail: 'api/column/getcolumngoodscatedetail',
    // 商品列表
    goodsList: 'api/goods/goodslist',
    // 商品分类-商品列表
    goodsCateGoodsList: 'api/goods/getcategoods',
    // 商品详情
    goodsDetail: 'api/goods/detail',
    // 商品详情-商品评论列表
    goodsCommentList: 'api/order/commentlist',
    // 商品详情-发表评论
    goodsPublishComment: 'api/order/addcomment',
    // 商品详情-评论点赞
    goodsCommentLike: 'api/order/commentlike',
    // 提交商品订单
    submitGoodsOrder: 'api/order/submit',
    // 商品试用下单
    submitTryGoodsOrder: 'api/order/trysubmit',
    // 商品订单详情
    goodsOrderDetail: 'api/order/orderdetail',
    // 获取订单付款码
    orderQrcode: 'api/order/qrcode',
    orderWap: 'api/order/wap',
    // 获取Web3.0后台账户信息
    getAppletAccount: 'api/wxsystemuser/store',
    // 服务商列表
    serviceList: 'api/service/getlist',
    // 服务商详情
    serviceDetail: 'api/service/getdetail',
    // 服务商-商品列表
    serviceGoodsList: 'api/service/goodslist',
    // 服务商-成功案例
    serviceCaseList: 'api/service/case',
    // 服务商申请
    serviceApply: 'api/service/apply',
    // 委托开通提交
    commissionApply: 'api/commissioning/apply',
    // 课程列表
    courseList: 'api/course/getlist',
    // 课程详情
    courseDetail: 'api/course/detail',
    // 课程详情-推荐课程
    recomendCourseList: 'api/course/recommend',
    // 课程详情-相关课程
    aboutCourseList: 'api/course/relevant',
    // 课程详情-评论列表
    courseCommentList: 'api/course/commentlist',
    // 课程详情-发表评论
    coursePublishComment: 'api/course/addcomment',
    // 课程详情-评论点赞
    courseCommentLike: 'api/course/commentlike',
    // 课程详情-提交课程订单
    submitCourseOrder: 'api/order/coursesubmit',
    // 课程订单详情
    courseOrderDetail: 'api/order/courseorderdetail',
    // 获取课程订单付款码
    courseOrderQrcode: 'api/order/courseqrcode',
    courseOrderWap: 'api/order/course_wap',
    // 合作伙伴汇总数据
    partnerData: 'api/columngoodscate/partner',
    // 交付方式
    payTypeList: 'api/paytype/index',
    // 操作系统
    systemList: 'api/system/index',
    // 技术领域
    technicalfieldList: 'api/technicalfield/index',
    // 文章详情-相关阅读
    aboutReadArticleList: 'api/columngoodscate/relevant',
    // 文章详情-最新阅读
    newReadArticleList: 'api/columngoodscate/newslist',
    // 文章详情-上下篇
    updownArticles: 'api/columngoodscate/nearlist',
    // 文章详情-点赞
    likeArticle: 'api/columngoodscate/like',
    // 文章详情-收藏
    collectionArticle: 'api/columngoodscate/collection',
    // 文章详情-评论列表
    articleCommentList: 'api/columngoodscate/commentlist',
    // 文章详情-发表评论
    articlePublishComment: 'api/columngoodscate/addcomment',
    // 文章详情-评论点赞
    articleCommentLike: 'api/columngoodscate/commentlike',
    // 用户角色
    roleList: 'api/role/index',
    // 搜索
    search: 'api/search/index',
    // configImage: 'api/upload/image',
    configImage: 'api/config/image'
};
Object.keys(urls).forEach(el => {
    urls[el] = defaultUrl + urls[el];
});
export default urls;


// WEBPACK FOOTER //
// ./src/ws/api.js